<style lang="less" scoped>
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }
  .in-sec {
    width: 1200px;
    margin: 0 auto;
  }
  .car-1 { width: 287px; height: 255px; background: url(~@/assets/car-1.png) no-repeat; }
  .car-2 { width: 330px; height: 278px; background: url(~@/assets/car-2.png) no-repeat; }
  .car-3 { width: 461px; height: 298px; background: url(~@/assets/car-3.png) no-repeat; }

  .pc-1 { width: 163px; height: 210px; background: url(~@/assets/pc-1.png) no-repeat; }
  .pc-2 { width: 98px; height: 194px; background: url(~@/assets/pc-2.png) no-repeat; }
  .pc-3 { width: 91px; height: 162px; background: url(~@/assets/pc-3.png) no-repeat; }
  .pc-4 { width: 176px; height: 222px; background: url(~@/assets/pc-4.png) no-repeat; }

  .phone-1 { width: 865px; height: 542px; background: url(~@/assets/phone-1.png) no-repeat; }

  .in-sec {
    position: relative; height: 700px;
    .abs-sec>div {
      position: absolute;
    }
  }
  .car-1 { left: 300px; top: 330px; z-index: 3; }
  .car-2 { left: 403px; top: 289px; z-index: 2; }
  .car-3 { left: 296px; top: 161px; z-index: 1; }

  .pc-1 { left: 697px; top: 163px; z-index: 1; }
  .pc-2 { left: 506px; top: 38px; z-index: 0; }
  .pc-2 span {
    display: block; position: absolute; left: 48px; top: 95px;
    width: 3px; height: 100px; background: url(~@/assets/pc-2-line.png) no-repeat;
    animation: play 5s steps(16) infinite;
  }
  @keyframes play {
    from {
      background-position: 0 0;
    }
    to {
      background-position: -48px 0;
    }
  }
  .pc-3 { left: 255px; top: 399px; z-index: 1; }
  .pc-3+span {
    display: block; position: absolute; left: 273px; top: 514px;
    width: 73px; height: 47px; background: url(~@/assets/pc-3.gif) no-repeat;
  }
  .pc-4 { left: 54px; top: 14px; z-index: 1; }

  .pc-1 span {
    display: block; position: absolute; left: 12px; top: 145px;
    width: 41px; height: 51px; background: url(~@/assets/pc-1.gif) no-repeat;
  }
  .pc-3 span {
    display: block; position: absolute; left: 18px; top: 115px;
    width: 73px; height: 47px; background: url(~@/assets/pc-3.gif) no-repeat;
  }
  .pc-4 span {
    display: block; position: absolute; left: 73px; top: 128px;
    width: 96px; height: 94px; background: url(~@/assets/pc-4.gif) no-repeat;
  }

  .phone-1 { left: 51px; top: 158px; z-index: 0; }

  @media only screen and (max-width: 768px) {
    .in-sec {
      width: 100%; overflow: hidden; height: 320px;
    }
    .abs-sec {
      .abs-lcenter; margin-left: -220px;
    }
    .car-1 {
      left: 129px; top: 136px;
      width: 143px; height: 127px;
      background-size: cover;
    }
    .car-2 {
      left: 170px; top: 110px;
      width: 165px; height: 139px;
      background-size: cover;
    }
    .car-3 {
      left: 135px; top: 55px;
      width: 230px; height: 149px;
      background-size: cover;
    }
    .pc-1 {
      left: 347px; top: 58px;
      width: 81px; height: 105px;
      background-size: cover;
      span {
        left: 9px; top: 74px;
        width: 20px; height: 25px;
        background-size: cover;
      }
    }
    .pc-2 {
      left: 247px; top: 5px;
      width: 49px; height: 87px;
      background-size: cover;
      span {
        left: 24px; top: 48px;
        width: 1.5px; height: 50px;
        background-size: cover;
        animation: play 5s steps(13) infinite;
      }
    }
    @keyframes play {
      from {
        background-position: 0 0;
      }
      to {
        background-position: -24px 0;
      }
    }
    .pc-3 {
      left: 109px; top: 170px;
      width: 45px; height: 81px;
      background-size: cover;
      &+span {
        left: 118px; top: 222px;
        width: 36px; height: 24px;
        background-size: cover;
      }
    }
    .pc-4 {
      left: 14px; top: 7px;
      width: 70px; height: 66px;
      background-size: cover;
      span {
        width: 48px; height: 47px; left: 29px; top: 44px;
        background-size: cover;
      }
    }

    .phone-1 {
      left: 14px; top: 50px;
      width: 432px; height: 271px;
      background-size: cover;
    }
  }
</style>

<template lang="pug">
  .intro-container
    .in-sec
      .abs-sec
        div.car-1
        div.car-2
        div.car-3
        div.pc-1 #[span]
        div.pc-2 #[span]
        div.pc-3
        span
        div.pc-4 #[span]
        div.phone-1
</template>

<script>
export default {

};
</script>
